// ============================================================
// Digital Content Module — Router (index.tsx)
// Lazy-loads all 5 sub-routes for the digital-content module.
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const VideoUpload = lazy(() => import('./video-upload/VideoUpload'));
const AddVideoMapping = lazy(
  () => import('./add-video-mapping/AddVideoMapping')
);
const VideoRating = lazy(() => import('./video-rating/VideoRating'));
const CareerGuidance = lazy(() => import('./career-guidance/CareerGuidance'));
const VideoUpdated = lazy(() => import('./video-updated/VideoUpdated'));

const DigitalContentModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="video-upload" element={<VideoUpload />} />
        <Route path="addvideomapping" element={<AddVideoMapping />} />
        <Route path="videorating" element={<VideoRating />} />
        <Route path="career-guidance" element={<CareerGuidance />} />
        <Route path="video-updated" element={<VideoUpdated />} />
      </Routes>
    </Suspense>
  );
};

export default DigitalContentModule;
